import { render } from "./cover.vue?vue&type=template&id=b0c0db80&scoped=true&ts=true"
import script from "./cover.vue?vue&type=script&lang=ts"
export * from "./cover.vue?vue&type=script&lang=ts"

import "./cover.vue?vue&type=style&index=0&id=b0c0db80&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c0db80"]])

export default __exports__